import { createContext } from 'react';

const PartnerContext = createContext({});

export default PartnerContext;
